import type { ReactNode } from 'react';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { UserRole, useUser } from '../hooks/useUser';
import { Loader } from './Loader';

interface RoleGuardProps {
	children: ReactNode;
	allowedRoles: UserRole[];
	fallbackPath?: string;
}

/**
 * Role-based route protection component
 * Renders children if user has required role, otherwise redirects
 */
export const RoleGuard: React.FC<RoleGuardProps> = ({
	children,
	allowedRoles,
	fallbackPath = '/',
}) => {
	const user = useUser();

	// Still loading user data - show loading indicator
	if (user.isLoading) {
		return <Loader />;
	}

	// Check if user role is in allowed roles
	const userRole = user.role || 'client';
	const hasAccess = allowedRoles.includes(userRole);

	if (!hasAccess) {
		return <Navigate to={fallbackPath} replace />;
	}

	return <>{children}</>;
};
